class ScxSwiperOutblock extends HTMLElement {
  constructor() {
    super();
    this.debounce = this.debounce.bind(this);
  }

  connectedCallback() {
    this.firstSwiperElem = this.querySelector(this.dataset.swiperElem);
    this.bannerElem = this.querySelectorAll(this.dataset.bannerId);

    if(!this.firstSwiperElem || !this.bannerElem) {
      return ;
    }    

    const onResize = this.debounce((entry) => {
      const width = entry.contentRect.width;

        this.bannerElem?.forEach((banner) => {
          // Small correction to avoid loops.
                    
          if(!banner.style.width || Math.abs(parseFloat(banner.style.width) - width) > 1) {
            banner.style.width = `${width}px`;
          }
        })
        
    }, 0);

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        onResize(entry);
      }
    });

    if (this.firstSwiperElem) {
      observer.observe(this.firstSwiperElem);
    } else {
      console.warn("⚠️ firstSwiperElem not found", this.dataset.swiperElem);
    }
  }

  debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }
}

customElements.define("scx-swiper-outblock", ScxSwiperOutblock);
